var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconProjectNewFilled = function SvgIconProjectNewFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.33 17.38-5.243-3.043a1.32 1.32 0 0 1-.67-1.156V6.82a1.31 1.31 0 0 1 .67-1.156l5.222-3.022q.315-.184.691-.184.377 0 .69.184l5.223 3.022a1.32 1.32 0 0 1 .67 1.156v6.362a1.31 1.31 0 0 1-.67 1.156L10.67 17.38a1.32 1.32 0 0 1-1.34 0m.128-7.063v5.866l.43.253a.2.2 0 0 0 .112.032q.056 0 .112-.032l.43-.253v-5.866l4.958-2.87v-.684a.2.2 0 0 0-.02-.08.15.15 0 0 0-.06-.064l-.337-.186L10 9.365 4.896 6.433l-.316.186a.15.15 0 0 0-.06.064.2.2 0 0 0-.02.08v.684z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconProjectNewFilled);
export { ForwardRef as ReactComponent };